module.exports = {
    BASE_URL: `${window.location.origin}`
    // BASE_URL: `http://192.168.1.94:10010`
}
